import {CSSProperties, useEffect} from 'react';
import { useParams } from 'react-router';
import { useAmrDataRequestForm, useDataRequest } from '@vivli/features/data-requests/infrastructure/hook';
import { DataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { AmrDataRequestComponent } from '@vivli/features/data-requests/components';
import { DataRequestContextWrapper, StatusUpdateContextWrapper } from '@vivli/features/data-requests/infrastructure/wrappers';
import { NotificationContextWrapper } from '@vivli/shared/features/notification/infrastructure/wrappers';
import { FormProvider } from 'react-hook-form';

const containerStyle: CSSProperties = {
    backgroundColor: 'rgb(233, 234, 239)',
    overflow: 'hidden',
    transform: 'translate3d(0,0,0)', // force chrome to use GPU for rendering - fixes UI 'whiteout' glitch related to scrollbars (I think),
    display: 'flex',
    flexDirection: 'column',
    minWidth: '100%',
    flexGrow: 2,
    height: '100%'
};

export const AmrDataRequestFeature = () => {
    const { requestId } = useParams();
    const { dataRequest } = useDataRequest(requestId);
    const formApi = useAmrDataRequestForm(dataRequest);

    useEffect(() => {
        if (!dataRequest) return;

        formApi.reset(dataRequest);
    }, [dataRequest])


    if (!dataRequest) {
        return <LoadIndicatorCenteredView />;
    }

    return (
        <div style={containerStyle}>
            <FormProvider {...formApi}>
                <DataRequestContextWrapper dataRequest={dataRequest}>
                    <DataRequestContext.Consumer>
                        {({ organizations }) => {
                            if (!organizations) {
                                return <LoadIndicatorCenteredView />;
                            }

                            return (
                                <StatusUpdateContextWrapper>
                                    <NotificationContextWrapper>
                                        <AmrDataRequestComponent />
                                    </NotificationContextWrapper>
                                </StatusUpdateContextWrapper>
                            );
                        }}
                    </DataRequestContext.Consumer>
                </DataRequestContextWrapper>
            </FormProvider>
        </div>
    );
};
